import { SIconButton, STag } from './MemoryToolBar.styled'
import { ReactElement } from 'react'

export function AnimateActionButton(props: {
  title?: string
  onClick: () => void
  icon: ReactElement
  hasNewTag?: boolean
  hideTitle?: boolean
}) {
  return (
    <SIconButton type="button" variant="text" onClick={props.onClick} leftIcon={props.icon}>
      {props.hasNewTag && <STag>NEW</STag>}

      {!props.hideTitle && props.title}
    </SIconButton>
  )
}
